module.exports = JBrowseExports["mobx"];